import './grid.scss';

import * as gzGrid from './grid.directive';
import cacheGridImages from './cache-images.run.js';

import * as editColumns from './columns/columns-dialog.controller';
import * as editSort from './sort/sort-dialog.controller';
import '../../components/filters/filter-dialog/filter-dialog.scss';
import './columns/columns-dialog.scss';
import './sort/sort-dialog.scss';
import gazelleAnalytics from '../../core/analytics/analytics.module';

export default angular.module('gazelle.components.grid', [
  'agGrid',
  'angularMoment',
  'pascalprecht.translate',
  'gazelle.components.filters',
  'gazelle.components.fields',
  'rhino.components.preferences',
  'rhino.core',
  gazelleAnalytics
])
  .run(cacheGridImages)
  .directive(gzGrid.name, gzGrid.default)
  .controller(editColumns.name, editColumns.default)
  .controller(editSort.name, editSort.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/grid/grid.module.js